module.exports = __webpack_public_path__ + "12333ffe8a17ede83c2d63ec75cc1a45.svg";